import { ArrowLeft, Edit2, Building2, Calendar, Package, Globe,ExternalLink } from 'lucide-react';

export const CompanyDetailsView = ({
                                       company,
                                       products = [],
                                       onBack,
                                       onEdit,
                                       onViewProducts
                                   }) => {
    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="flex items-center gap-4">
                <button
                    onClick={onBack}
                    className="p-2 hover:bg-gray-100 rounded-lg transition"
                >
                    <ArrowLeft className="w-5 h-5" />
                </button>
                <h2 className="text-2xl font-semibold text-gray-900">Company Details</h2>
            </div>

            {/* Company Info Card */}
            <div className="bg-white rounded-lg border border-gray-200 p-6">
                <div className="flex justify-between items-start mb-6">
                    <div className="flex items-center gap-4">
                        <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center">
                            <Building2 className="w-8 h-8 text-blue-600" />
                        </div>
                        <div>
                            <h3 className="text-2xl font-bold text-gray-900">{company.name}</h3>
                            <p className="text-gray-500">Code: {company.code}</p>
                        </div>
                    </div>
                    <div className="flex items-center gap-2">
                        <span className={`px-3 py-1 text-sm rounded-full ${
                            company.active
                                ? 'bg-green-100 text-green-800'
                                : 'bg-gray-100 text-gray-800'
                        }`}>
                            {company.active ? 'Active' : 'Inactive'}
                        </span>
                        <button
                            onClick={() => onEdit(company)}
                            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition flex items-center gap-2"
                        >
                            <Edit2 className="w-4 h-4" />
                            Edit Company
                        </button>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <h4 className="text-sm font-medium text-gray-500 mb-2">Business Scope</h4>
                        <div className="flex items-center gap-2">
                            <Globe className="w-5 h-5 text-gray-400" />
                            <p className="text-gray-900">{company.businessScope}</p>
                        </div>
                    </div>

                    <div>
                        <h4 className="text-sm font-medium text-gray-500 mb-2">Products</h4>
                        <button
                            onClick={() => onViewProducts(company)}
                            className="flex items-center gap-2 text-blue-600 hover:text-blue-700 transition"
                        >
                            <Package className="w-5 h-5" />
                            <span>{products.length} products</span>
                            <ExternalLink className="w-4 h-4" />
                        </button>
                    </div>

                    {company.description && (
                        <div className="md:col-span-2">
                            <h4 className="text-sm font-medium text-gray-500 mb-2">Description</h4>
                            <p className="text-gray-900">{company.description}</p>
                        </div>
                    )}

                    <div className="md:col-span-2 pt-4 border-t border-gray-200">
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                            <div>
                                <p className="text-gray-500">Created</p>
                                <div className="flex items-center gap-1 text-gray-900">
                                    <Calendar className="w-4 h-4 text-gray-400" />
                                    <p>{company.createdAt ? new Date(company.createdAt).toLocaleDateString() : 'N/A'}</p>
                                </div>
                            </div>
                            <div>
                                <p className="text-gray-500">Last Updated</p>
                                <div className="flex items-center gap-1 text-gray-900">
                                    <Calendar className="w-4 h-4 text-gray-400" />
                                    <p>{company.updatedAt ? new Date(company.updatedAt).toLocaleDateString() : 'N/A'}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Quick Products Preview */}
                {products.length > 0 && (
                    <div className="mt-6 pt-6 border-t border-gray-200">
                        <div className="flex justify-between items-center mb-4">
                            <h4 className="font-medium text-gray-900">Recent Products</h4>
                            <button
                                onClick={() => onViewProducts(company)}
                                className="text-sm text-blue-600 hover:text-blue-700"
                            >
                                View all products →
                            </button>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                            {products.slice(0, 3).map(product => (
                                <div key={product.id} className="p-3 bg-gray-50 rounded-lg">
                                    <p className="font-medium text-sm text-gray-900">{product.name}</p>
                                    <p className="text-xs text-gray-500">Code: {product.code}</p>
                                    <span className={`inline-block mt-1 px-2 py-1 text-xs rounded-full ${
                                        product.active
                                            ? 'bg-green-100 text-green-800'
                                            : 'bg-gray-100 text-gray-800'
                                    }`}>
                                        {product.active ? 'Active' : 'Inactive'}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
 export default CompanyDetailsView;
